:global(.main-screen.small-screen.chat-view-open) .chatListAndHeaderAndAudioPlayer {
  display: none;
}

:global(.main-screen.small-screen:not(.chat-view-open)) .chatView {
  display: none;
}

:global([data-testid="voice-message-strip"]) ~ .chatListAndHeaderAndAudioPlayer .chatListHeader,
:global([data-testid="voice-message-strip"]) ~ .chatView > nav {
  margin-bottom: 38px;
}

.chatListAndHeaderAndAudioPlayer {
  display: flex;
  flex-direction: column;
  width: 0;
  flex-grow: 3;
  min-width: 295px;
}
.chatListAndHeaderAndAudioPlayer .chatListAndHeader {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.chatListAndHeaderAndAudioPlayer .chatListHeader {
  height: var(--navBarHeight);
  background-color: var(--navBarBackground);
  color: var(--navBarText);
  border-bottom: var(--outlineProperties);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0px 10px;
}
.chatListAndHeaderAndAudioPlayer .chatListHeader .archivedChatsTitle {
  flex: 1 1 auto;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 18px;
  user-select: none;
}
.chatListAndHeaderAndAudioPlayer .chatListHeader .proxyButton {
  padding-inline-end: 0px;
}

.chatListResizeHandle {
  flex: 0 0 5px;
  cursor: col-resize;
  margin-inline-end: -5px;
  z-index: 1;
}
.chatListResizeHandle:hover, .chatListResizeHandle:focus-visible {
  background-color: var(--scrollbarThumb);
}
.chatListResizeHandle:active {
  background-color: var(--scrollbarThumbHover);
}

.chatView {
  width: 0;
  flex-grow: 8;
}